import React, {Component} from 'react';
import Input from './input-with-label';
import Checkbox from './checkbox';
import NavLink from '../react/nav-link';

import SeamApi from '../../lib/seam-api';


const checkboxes = [

    {
        text: 'Please add me to DMC’s Mailing List',
        id: 1
    }
];

class CoWorkingForm extends Component {


    constructor(props) {
        super(props);
        this.state = {
            accept: false,
            acceptError : false,
            permissions: {},
            errors : {},
            success:  false
        };
    }

    handleChange(e) {
        this.setState({
            errors:  {},
            [e.target.name] : e.target.value,
        });
    }

    handleErrors(data) {
        this.setState({errors : data});
    }

    formatParams() {
        const fields  = ['first_name', 'last_name', 'email', 'phone_number', 'mobile_number', 'message'];

        let params = {
            source_distribution_id : 1,
            subject: 'Co-Working Booking',
            contact_permissions : [],
            email: this.state?.email,
            first_name: this.state?.first_name,
            last_name: this.state?.last_name,
            phone_number: this.state?.phone_number || null,
            mobile_number: this.state?.mobile_number || null,
            message: this.state?.message,
            admin_team_id: 1,
            meta: this.props.params,
        };

        fields.forEach((field) => {
           if(this.state.hasOwnProperty(field)) {
               if(this.state[field].length >= 1) {
                   params[field] = this.state[field];
               }
           }
        });

         _.each(this.state.permissions, (i, index) => {
             if(i === true) {
                 params.contact_permissions.push(parseInt(index));
             }
        });


        return params;

    }

    handleSubmit() {
        if(this.state.accept === false) {
            return this.setState({ acceptError : true });
        }

        this.setState({ acceptError : false });

        SeamApi.contacts().message(this.formatParams(), this.handleErrors.bind(this)).then(() => {
            this.setState({ success : true});
        });
    }

    getErrors(name) {
        return this.state.errors.hasOwnProperty(name) ? this.state.errors[name]  : [];
    }

    render() {
        return (
            <>
                <div className="overlay-speak__column">
                    <Input name="first_name" value={this.state.first_name} placeholder="Your First Name" onChange={this.handleChange.bind(this)}  errors={this.getErrors('first_name')}/>

                    <Input name="last_name" value={this.state.last_name} placeholder="Your Last Name" onChange={this.handleChange.bind(this)} errors={this.getErrors('last_name')}/>

                </div>
                <div className="overlay-speak__column">
                    <Input name="company_name" value={this.state.company_name} placeholder="Your Business Name" onChange={this.handleChange.bind(this)} />
                    <Input type={'email'} name="email" value={this.state.email} placeholder="Your Email Address" onChange={this.handleChange.bind(this)} errors={this.getErrors('email')}/>
                </div>
                <div className="overlay-speak__column">
                    <Input name="mobile_number" value={this.state.mobile_number} placeholder="Your Mobile Number" onChange={this.handleChange.bind(this)} errors={this.getErrors('mobile_number')}/>
                    <Input name="phone_number" value={this.state.phone_number} placeholder="Your Landline Number" onChange={this.handleChange.bind(this)} errors={this.getErrors('phone_number')}/>

                </div>
                <div className="overlay-speak__column">
                    <p className="speak-column__title">Please tell us your required date, session duration and qty of attendees.</p>
                    <div className="overlay-speak__column-bottom">
                        <textarea className={'input'} name={'message'} onChange={this.handleChange.bind(this)}/>
                        <div className="overlay__bottom overlay-speak__bottom">
                            <div className='overlay-section__checkboxes'>
                                {checkboxes.map(({text, id}, index) => {
                                    return (
                                        <div key={id} className="checkbox__outer">
                                            <Checkbox
                                                ariaLabelledby="label__mail-two"
                                                checked={this.state.permissions.hasOwnProperty(id) && this.state.permissions[id] === true}
                                                square={true}
                                                toggleCheckBox={() => this.setState({
                                                    permissions: Object.assign({}, this.state.permissions, {
                                                        [id]: !this.state.permissions[id]
                                                    })
                                                })} />
                                            <p id="label__mail-two">{text}</p>
                                        </div>
                                    )
                                })}
                                <div className="checkbox__outer">
                                    <Checkbox
                                        ariaLabelledby="label__policy-three"
                                        checked={this.state.accept}
                                        square={true}
                                        toggleCheckBox={() => this.setState({ accept : !this.state.accept, acceptError: false })}/>
                                    <p id="label__policy-three">I Accept the <a target={'_blank'} rel={'noreferrer'} href="https://www.barnsley.gov.uk/services/information-and-privacy/your-privacy/">privacy policy</a></p>
                                </div>

                                {this.state.acceptError && <div className="input-outer__errors"><p>Please accept our privacy policy</p></div> }

                            </div>
                            { !this.state.success && <div className="overlay-speak__send">
                                <NavLink text="SEND" color="green" onClick={this.handleSubmit.bind(this)}/>
                            </div> }
                        </div>
                    </div>
                    <div className="overlay-speak__column">
                        {
                            this.state.success &&
                            <div className="overlay-speak__success">
                                Thank you for contacting us! Your enquiry will be seen to by our experience team and responded to shortly.
                            </div>
                        }
                    </div>
                </div>



            </>
        );
    }
}

export default CoWorkingForm;
